const wizardGetters = {
    getCourses(state){
        return state.courses;
    },
    getSelectedCourse(state){
        return state.selected.course;
    },
    getSelectedUser(state){
        return state.selected.user;
    },
    getSelecteds(state){
        return state.selected;
    },
    getRegistration(state){
        return state.registration;
    }

};

export default wizardGetters;
